<sbw-popup [allowXL]="true" [showPopup]="showPopup" (showPopupChange)="showPopupChange.emit($event)">
    <div (click)="showPopupChange.emit(false)" *ngIf="content" class="hide-for-small-down desktop">
        <h3>{{content.titleDesktop}}</h3>
        <table>
            <tr>
                <td class="header"></td>
                <th class="tier1">{{content.tier1Name}}</th>
                <th class="tier2">{{content.tier2Name}}</th>
                <th class="tier3">{{content.tier3Name}}</th>
            </tr>
            <tr *ngFor="let row of rows">
                <td><strong>{{content[row.row]}}</strong></td>
                <td>{{content[row.tier1]}}</td>
                <td>{{content[row.tier2]}}</td>
                <td>{{content[row.tier3]}}</td>
            </tr>
        </table>
    </div>

    <div *ngIf="content" class="hide-for-medium-up mobile">
        <h3>{{content.titleMobile}}</h3>
        <table *ngFor="let tier of tiers">
            <tr class="noselect" (click)="tier.expanded = !tier.expanded">
                <th [class]="tier.tier">{{content[tier.name]}}<span [class]="tier.rotation()"></span></th>
            </tr>
            <ng-container *ngIf="tier.expanded">
                <tr *ngFor="let row of rows">
                    <td>
                        <strong>{{content[row.row]}}</strong>
                        <br>
                        {{content[row[tier.tier]]}}
                    </td>
                </tr>
            </ng-container>
        </table>
    </div>

    <ul>
        <li *ngFor="let footnote of footnotes">{{footnote}}</li>
    </ul>

</sbw-popup>